module.exports = __webpack_public_path__ + "img/luxora.eb6156c0.png";